module.exports = __webpack_public_path__ + "img/downloadIcon.aea67285.svg";